document.addEventListener('DOMContentLoaded', function () {
    'use strict';

    document.querySelectorAll('.media-gallery-slideshow').forEach(function (swiperObject) {
        var swiperEl = swiperObject.querySelector('.swiper');
        var transition_duration = parseInt(swiperEl.dataset.transitionDuration) || 700;
        var interval_duration = parseInt(swiperEl.dataset.intervalDuration) || 6000;
        var gallery_autoplay = swiperEl.dataset.galleryAutoplay === 'true';
        var gallery_navigation = swiperEl.dataset.galleryNavigation === 'true';

        new Swiper(swiperEl, {
            speed: transition_duration,
            autoplay: gallery_autoplay ? { delay: interval_duration } : false,
            spaceBetween: 0,
            grabCursor: true,
            slidesPerView: 1,
            navigation: gallery_navigation
                ? {
                    nextEl: swiperObject.querySelector('.swiper-button-next'),
                    prevEl: swiperObject.querySelector('.swiper-button-prev'),
                }
                : false,
        });
    });
});

//# sourceMappingURL=swiper-slideshow.js.map
